// removed by extract-text-webpack-plugin
module.exports = {"appContainer":"Container__appContainer__2-WkI"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Container/Container.css
// module id = 238
// module chunks = 0